var render, staticRenderFns
import script from "./BBoxTool.vue?vue&type=script&lang=js&"
export * from "./BBoxTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BBoxTool.vue"
export default component.exports